import { makeStyles } from '@material-ui/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import { COLOR_ARRAY } from '_core/utils/colors';


export const style = (theme) => ({
  root: {},
  
  container: {
    margin: theme.spacing(2)
  },
  
  filterPeriod: {
    overflow: 'hidden',
    
    width: 400,
    maxWidth: '100%',
    
    '& .MuiOutlinedInput-notchedOutline': {
      borderStyle: 'none'
    }
  },
  
  filterHeader: {
    color: theme.palette.secondary.main
  },
  
  filterSearchInput: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0
    }
  },
  
  filterList: {
    width: '100%'
  },
  
  filterListNoPadding: {
    padding: 0
  },
  
  filterStatusList: {
    flexDirection: 'column',
    alignItems: 'stretch',
    overflow: 'auto',
    padding: 0,
    maxHeight: 160
  },
  
  filterApply: {
    gap: theme.spacing(1),
    
    '& .MuiButton-root': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  },
  
  filterAllBtn: {
    color: theme.palette.getContrastText(theme.palette.background.paper),
    
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  
  filterExportBtn: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: 0,
    paddingBottom: 0
  },
  
  filterInput: {
    '& input': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5)
    }
  },
  
  filterInputFromTo: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    
    '& > div': {
      width: 150
    }
  },
  
  filterInputFromToDate: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(1),
      
      width: 250
    }
  },
  
  filterValues: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    paddingTop: 0,
    
    minWidth: 250,
    maxWidth: 500,
    
    '& $statusChip': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.getContrastText(theme.palette.background.default),
      pointerEvents: 'all',
      
      '& svg': {
        fontSize: 16,
        
        display: 'flex'
      }
    }
  },
  
  exportPropTitle: {
    color: theme.palette.getContrastText(theme.palette.background.paper)
  },
  
  exportFormatList: {
    transition: 'max-height 0.15s ease-in',
    
    flexDirection: 'column',
    alignItems: 'stretch',
    overflow: 'hidden',
    padding: 0,
    maxHeight: 0
  },
  
  exportFormatOpen: {
    maxHeight: 500
  },
  
  headerContainer: {
    display: 'flex',
    overflow: 'hidden',
    
    width: 'calc(100% - 100px)'
  },
  
  headerCell: {
    transition: 'width 0.3s ease, min-width 0.3s ease',
    
    display: 'flex',
    alignItems: 'stretch',
    overflow: 'hidden'
  },
  
  headerCellInner: {
    display: 'flex'
  },
  
  headerCellBtn: {
    color: theme.palette.getContrastText(theme.palette.background.paper),
    textAlign: 'left',
    
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  
  headerShiftBtn: {
    backgroundColor: lighten(theme.palette.primary.main, 0.85),
    color: theme.palette.getContrastText(lighten(theme.palette.primary.main, 0.85)),
    
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    borderStyle: 'none',
    borderRadius: '50%',
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    
    width: 24,
    height: 24,
    
    '&:disabled': {
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
      color: lighten(theme.palette.primary.main, 0.75)
    }
  },
  
  row: {
    transition: 'background-color 0.1s ease',
    color: theme.palette.getContrastText(theme.palette.background.paper),
    
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    
    position: 'relative',
    
    '&:hover': {
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
      color: theme.palette.getContrastText(lighten(theme.palette.primary.main, 0.95))
    }
  },
  
  rowSelected: {
    backgroundColor: lighten(theme.palette.primary.main, 0.95),
    color: theme.palette.getContrastText(lighten(theme.palette.primary.main, 0.95)),
    
    '&::after': {
      content: '""',
      pointerEvents: 'none',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main,
      borderRadius: theme.spacing(1),
      
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    }
  },
  
  rowColumns: {
    display: 'flex',
    overflow: 'hidden',
    
    position: 'relative',
    width: '100%',
    
    '&::after': {
      background: 'linear-gradient(to right, transparent, ' + theme.palette.background.paper + ')',
      
      content: '""',
      pointerEvents: 'none',
      
      position: 'absolute',
      right: 0,
      top: 0,
      width: 150,
      height: '100%'
    }
  },
  
  cell: {
    transition: 'width 0.3s ease, min-width 0.3s ease',
    
    display: 'flex',
    alignItems: 'stretch',
    overflow: 'hidden'
  },
  
  cellInner: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    overflow: 'hidden',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  
  expandBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    
    borderRadius: '50%',
    marginLeft: -8 + 1,
    marginTop: -8 - 1,
    
    position: 'absolute',
    left: 0,
    top: '50%',
    width: 16,
    height: 16
  },
  
  expandIcon: {
    width: '100%',
    height: '100%'
  },
  
  treeContainer: {
    display: 'flex',
    paddingLeft: theme.spacing(1),
    
    width: 60
  },
  
  treeLine: {
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(-2),
    
    position: 'relative',
    width: '100%'
  },
  
  treeLineTop: {
    borderWidth: 2,
    borderColor: lighten(theme.palette.primary.main, 0.7),
    borderLeftStyle: 'solid',
    
    position: 'absolute',
    left: 0,
    top: 0,
    height: '50%'
  },
  
  treeLineBottom: {
    borderWidth: 2,
    borderColor: lighten(theme.palette.primary.main, 0.7),
    borderLeftStyle: 'solid',
    
    position: 'absolute',
    left: 0,
    top: '50%',
    height: '50%'
  },
  
  treeLineRootArrow: {
    color: lighten(theme.palette.primary.main, 0.7),
    
    borderWidth: 2,
    borderColor: lighten(theme.palette.primary.main, 0.7),
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderTopLeftRadius: theme.spacing(1),
    
    position: 'absolute',
    left: 0,
    top: '50%',
    width: '100%',
    height: '50%',
    
    '& $treeLineArrowIcon': {
      top: -8 - 1,
      bottom: 'auto'
    }
  },
  
  treeLineArrow: {
    color: lighten(theme.palette.primary.main, 0.7),
    
    borderWidth: 2,
    borderColor: lighten(theme.palette.primary.main, 0.7),
    borderLeftStyle: 'solid',
    borderBottomStyle: 'solid',
    borderBottomLeftRadius: theme.spacing(1),
    
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '50%'
  },
  
  treeLineArrowIcon: {
    position: 'absolute',
    right: -8 + 1,
    bottom: -8 - 1,
    width: 16,
    height: 16
  },
  
  value: {
    display: 'flex',
    alignItems: 'center',
    
    width: '100%'
  },
  
  childrenContainer: {
    overflow: 'hidden'
  },
  
  childrenMore: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: lighten(theme.palette.primary.main, 0.7),
    borderRadius: theme.spacing(1)
  },
  
  children: {
    //transition: 'margin-top 0.3s ease',
    
    //marginTop: '-100%'
    
    height: 0
  },
  
  childrenExpanded: {
    //marginTop: 0
    
    height: 'auto'
  },
  
  skeleton: {
    width: '100%'
  },
  
  skeletonAvatar: {
    width: 40,
    minWidth: 40,
    height: 40,
    minHeight: 40
  },
  
  statusChip: {
    backgroundColor: 'silver',
    color: 'white',
    pointerEvents: 'none',
    
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    borderRadius: 6,
    padding: '3px 8px',
    maxWidth: '100%',
    
    ...COLOR_ARRAY.reduce((result, color) => { result['&.text-' + color] = { backgroundColor: color }; return result; }, {}),
    
    '& > svg': {
      margin: 0,
      padding: 0,
      width: 13,
      height: 13
    },
    
    '& > div': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      
      overflow: 'hidden',
      width: '100%'
    }
  },
  
  modalAvatar: {
    width: 100,
    height: 100
  },
  
  modalUserInfo: {
    flexGrow: 1
  },
  
  modalUserInfoLogin: {
    marginRight: 32
  },
  
  modalColumn: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.getContrastText(theme.palette.background.default),
    
    borderRadius: 6,
    padding: theme.spacing(1),
    
    '& .material-icons': {
      fontSize: 14
    }
  }
});

export const useStyle = makeStyles(style);
